import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        locale: 'en',
        isActiveNav: false,
        projects:null,
        posts:null,
        activeImagePath: null,
        setScroll:false,
        loading: true,
        savedPositions:{}
    },
    getters: {

        getLocale(state) {
            return state.locale;
        },

        getProjectsByCategory:(state)=>(category)=>{
            return state.projects.filter((item) => {
                return item.category === category;
            });
        },
        getActiveProject:(state)=> (name)=> {
            return state.projects.find((item) => {
                return item.slug===name.toLowerCase();
            });
        },
        getImagesByProject:(state)=> (name)=> {
            let project = state.projects.find((item) => {
                return item.slug===name.toLowerCase();
            });


            let cover = {
                'path': project.path,
                'type': 'cover',
                'title': project.title,
                'description':project.description
            };

            let res=project.images.map((project_image)=>{
                let image = {};
                image.path = project_image.image_url;
                image.type = 'project-photo';
                image.title = null;

                return image;
            });

            res.unshift(cover);

            return res;
        },
        getFeaturedProjects(state){
            return state.projects.filter((item) => {
                return item.featured === true;
            }).sort((a, b) => (
                a.featured_position > b.featured_position) ? 1 : -1
            );
        },
        getFeaturedProjectsImages(state){
            return state.projects.filter((item) => {
                return item.featured === true;
            }).map((item)=>{
                return item.path;
            });
        }

    },
    mutations: {
        toggleNav(state) {
            state.isActiveNav = !state.isActiveNav
        },
        setActiveProjectPath(state, path) {
            state.activeImagePath = path;
        },
        setLocale(state, locale) {
            state.locale = locale;
            state.isActiveNav = false;
        },
        setLoading(state,loading){
            state.loading=loading;
        },
        setProjects(state,projects){
            state.projects = projects;
        },
        setPosts(state,posts){
            state.posts = posts;
        }
    },
    actions: {
        async init ({ commit,state }) {
            commit('setLoading', true);

            let url = process.env.VUE_APP_API_URL+'/api/initial_data'

            return await axios.get(url).then(
                (response)=> {
                    commit('setProjects', response.data.projects);
                    commit('setPosts', response.data.posts);
                    commit('setLoading', false);
                }
            )
        }
    },
    modules: {}
})
